import { __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { numeral } from '@holmescorp/numeral';
import { Button } from '@dojo/widgets/button';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { userstore, keymap, pathmap } from '@holmescorp/lcc-state';
import { ScoreRollup } from '../../support/score-rollup';
import { QuestionQueue } from '../../support/questionqueue';
import { BaseProgression } from '../base';
import css from '../../css/questionfeedback.m.css';
const isEmpty = (obj) => Object.keys(obj).length === 0;
const nextTopicGroup = (current) => {
    const { get, path } = userstore;
    const status = get(path('status'));
    return status[current].next;
};
let TopicQuestionFeedback = class TopicQuestionFeedback extends BaseProgression {
    next_prev() {
        const { quiz } = this.properties;
        const quizid = quiz.id;
        const currentTopic = quizid.match(/(topic\d+-[0-9-]*)/)[0];
        const { title: currentTitle, path: currentPath } = keymap.get(currentTopic);
        const nextTopic = nextTopicGroup(currentTopic);
        const { title: nextTitle, path: nextPath } = nextTopic ? keymap.get(nextTopic) : keymap.get('explore');
        return [
            v('div', { key: 'prev-next-block', classes: [this.theme(css.nextprev)] }, [
                v('div', {
                    key: 'prev-topic-group',
                    xqa: 'action prev',
                    classes: [this.theme(css.previous)],
                    onclick: (event) => {
                        event && event.stopPropagation();
                        console.log(`clicked ${currentPath}`);
                        pathmap.get(currentPath).view();
                    }
                }, [v('i', { classes: ['fa', 'fa-chevron-circle-left'] }), v('span', {}, [currentTitle])]),
                v('div', {
                    key: 'next-topic-group',
                    xqa: 'action next',
                    classes: [this.theme(css.next)],
                    onclick: (event) => {
                        event && event.stopPropagation();
                        console.log(`clicked ${nextPath}`);
                        pathmap.get(nextPath).view();
                    }
                }, [v('span', {}, [nextTitle]), v('i', { classes: ['fa', 'fa-chevron-circle-right'] })])
            ])
        ];
    }
    buttons() {
        const { messages } = this.properties.localizedBundle;
        const continueText = messages['continue'] || '';
        const restartText = messages['start_over'] || '';
        const beginText = messages['begin'] || '';
        const { quiz = {}, theme } = this.properties;
        const { use_restart } = quiz;
        const { svc } = this;
        if (use_restart) {
            return [
                v('div', { xqa: 'action continue', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'continue',
                        onClick: () => {
                            svc.continue_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup();
                            });
                        }
                    }, [continueText])
                ]),
                v('div', { xqa: 'action restart', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'restart',
                        onClick: () => {
                            svc.restart_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup(true);
                            });
                        }
                    }, [restartText])
                ])
            ];
        }
        else {
            return [
                v('div', { xqa: 'action begin', classes: [this.theme(css.oneaction)] }, [
                    w(Button, {
                        theme,
                        key: 'begin',
                        onClick: () => {
                            svc.start_quiz().then((v) => {
                                this.startquiz = v;
                                this.quiz_startup();
                            });
                        }
                    }, [beginText])
                ])
            ];
        }
    }
    render_page() {
        const { isPlaceholder, messages: { score: scoreText = '', last_score: lastScoreText = '' } } = this.properties.localizedBundle;
        if (isPlaceholder) {
            return [];
        }
        const { quiz = { id: 'topic' }, isrunning, quizstore } = this.properties;
        if (isrunning === 'quiz') {
            const { finalize, startquiz, svc } = this;
            return [
                w(QuestionQueue, { key: `${quiz.id}-queue`, svc, finalize, startquiz, quizstore })
            ];
        }
        else if (isrunning === 'final') {
            const { info } = this.properties;
            const lastresult = info && info.lastresult;
            const hasLastresult = lastresult && !isEmpty(lastresult);
            const percent = hasLastresult ? lastresult.totalpercentcorrect * 0.01 : 0;
            const { instructions_done } = quiz;
            return [
                v('div', {
                    key: 'instructions',
                    id: 'quiz-instructions',
                    classes: [this.theme(css.instructions)],
                    innerHTML: instructions_done
                }),
                hasLastresult
                    ? v('div', { key: 'score', classes: [this.theme(css.score)], xqa: 'last-quiz-score' }, [
                        v('span', { classes: [this.theme(css.scoreTitle)] }, [`${scoreText} `]),
                        v('span', { classes: [this.theme(css.scorePercent)] }, [`${numeral(percent).format('0%')}`])
                    ])
                    : v('div', { key: 'score', xqa: 'last-quiz-score' }),
                v('div', {
                    key: 'quiz-actions',
                    classes: [this.theme(css.actions)],
                    role: 'group',
                    ...formatAriaProperties({ labelledby: 'quiz-instructions' })
                }, this.next_prev())
            ];
        }
        else {
            const { info } = this.properties;
            const lastresult = info && info.lastresult;
            const hasLastresult = lastresult && !isEmpty(lastresult);
            const percent = hasLastresult ? lastresult.totalpercentcorrect * 0.01 : 0;
            const { instructions } = quiz;
            return [
                v('div', {
                    key: 'instructions',
                    id: 'quiz-instructions',
                    classes: [this.theme(css.instructions)],
                    innerHTML: instructions
                }),
                hasLastresult
                    ? v('div', { key: 'score', classes: [this.theme(css.score)], xqa: 'last-quiz-score' }, [
                        v('span', { classes: [this.theme(css.scoreTitle)] }, [`${lastScoreText} `]),
                        v('span', { classes: [this.theme(css.scorePercent)] }, [`${numeral(percent).format('0%')}`])
                    ])
                    : v('div', { key: 'score', xqa: 'last-quiz-score' }),
                v('div', {
                    key: 'quiz-actions',
                    classes: [this.theme(css.actions)],
                    role: 'group',
                    ...formatAriaProperties({ labelledby: 'quiz-instructions' })
                }, this.buttons())
            ];
        }
    }
    render() {
        const { quiz, info, key, quizstore } = this.properties;
        const hasdata = quiz && info;
        !hasdata && this.load_quiz();
        return v('div', { key, xqa: `progression question-feedback` }, hasdata
            ? [w(ScoreRollup, { key: `rollup-${key}`, quizstore }, this.render_page())]
            : this.render_loading());
    }
};
TopicQuestionFeedback = __decorate([
    theme(css)
], TopicQuestionFeedback);
export { TopicQuestionFeedback };
export default TopicQuestionFeedback;
